module.exports = __webpack_public_path__ + "static/img/img_welecome.e4ae688a.png";